import { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../../context/SocketContext";

export default function LivePl(props) {
  const item = props.item;
  const socket = useContext(SocketContext);

  const [pf, setpf] = useState(0);

  const socketTrade = (data) => {
    if (!data) return;

    const rate = parseFloat(item.rate);
    const qty = parseFloat(item.qty);
    const dollar_rate = parseFloat(item.dollar_rate || 1);
    const rupee_dollar = parseFloat(item.rupee_dollar);

    let profit = 0;

    if (item.buy_sell === 0) {
      // ✅ BUY position
      const bid = parseFloat(data.Bid);
      const ltp = parseFloat(data.LTP);
      const price =
        !isNaN(bid) && bid > 0 ? bid : !isNaN(ltp) && ltp > 0 ? ltp : 0;

      profit = (price - rate) * qty;
    } else if (item.buy_sell === 1) {
      // ✅ SELL position
      const ask = parseFloat(data.Ask);
      const ltp = parseFloat(data.LTP);
      const price =
        !isNaN(ask) && ask > 0 ? ask : !isNaN(ltp) && ltp > 0 ? ltp : 0;

      profit = (rate - price) * qty;
    }

    // ✅ Apply dollar conversion for specific types
    if (rupee_dollar === 0) {
      if (
        [
          "comex_future",
          "crypto_future",
          "forex_future",
          "us_stock",
          "index",
          "dgcx",
        ].includes(item.type)
      ) {
        profit *= dollar_rate;
      }
    }

    setpf(profit.toFixed(0));
  };

  useEffect(() => {
    if (!socket || !item.symbol_id) return;

    socket.emit("giverate", item.symbol_id);
    socket.on("trade" + item.symbol_id, socketTrade);

    return () => {
      socket.off("trade" + item.symbol_id, socketTrade);
    };
  }, []);

  // ✅ Notify parent component of PL change
  props.LivePlTotal(item.id, pf, props.total);

  return <div key={item.id} />;
}
